<script lang="ts">
      import { onMount } from 'svelte'
      import { createBodyContext } from './ts/BodyContext.svelte'
      import { getScrollBlockContext } from '$lib/ui/menu/index.svelte'
      import { getPageStateContext } from './ts/PageStateContext.svelte'
      import { page } from '$app/state'

      const body = createBodyContext()
      const scrollBlock = getScrollBlockContext()

      const pageState = getPageStateContext()

      let middle: HTMLElement

      onMount(() => {
            window._body = body
      })

      function blockScroll(opened: boolean) {
            if (opened == true) {
                  scrollBlock.requestBodyScrollBlock(middle)
            } else if (opened == false) {
                  scrollBlock.releaseBodyScrollBlock(middle)
            }
      }

      $effect(() => {
            blockScroll(body.opened)
      })


      let { children, before = undefined, after = undefined } = $props()
</script>

{@render before?.()}

<div bind:this={middle} class="wrapper {body.opened ? 'opened' : ''} w-full flex flex-col min-h-dvh absolute top-0 left-0 z-[10] fixed-element contain-paint">
      {@render children?.()}
      <div class="w-full h-full bg-white absolute top-0 left-0 z-[-200]"></div>
</div>

{@render after?.()}

<style lang="postcss">
      .wrapper {
            transition:
                  left 0.6s ease-in-out,
                  transform 0.6s ease-in-out,
                  box-shadow 0.6s ease-in-out;
      }

      .wrapper:global(.opened) {
            /*left: -44%;*/
            transform: translateX(-16rem);
            box-shadow: -5px 0 17px 0px #d7d7d7;
      }
</style>
